/* unplugin-vue-components disabled */import { render } from "./EdiTable.vue?vue&type=template&id=66ebdf13&scoped=true"
import script from "./EdiTable.vue?vue&type=script&lang=js"
export * from "./EdiTable.vue?vue&type=script&lang=js"

import "./EdiTable.vue?vue&type=style&index=0&id=66ebdf13&lang=stylus&scoped=true"

import exportComponent from "C:\\Users\\RedFlag\\Desktop\\code\\qms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ebdf13"]])

export default __exports__